import { Plan } from "../../types/Plan";
import DB_PATH from "../DB_PATH";
import { firestore } from "../firebase";

function stripUndefinedDeep(value: any): any {
  if (value === null || value === undefined) return value;
  if (Array.isArray(value)) {
    return value.map(stripUndefinedDeep).filter((item) => item !== undefined);
  }
  if (typeof value === "object") {
    const result: Record<string, any> = {};
    for (const key of Object.keys(value)) {
      const v = stripUndefinedDeep(value[key]);
      if (v === undefined) continue;
      result[key] = v;
    }
    return result;
  }
  return value;
}

export async function setPlan(plan) {
  const PlanRef = firestore.collection(DB_PATH.PLAN);
  const sanitized = stripUndefinedDeep(plan);

  try {
    if (sanitized.id) {
      await PlanRef.doc(sanitized.id).set(sanitized);
    } else {
      const newPlanRef = await PlanRef.add(sanitized);
      const newId = newPlanRef.id;

      const newPlan: Plan = {
        ...sanitized,
        id: newId,
      };

      await newPlanRef.update(newPlan);
    }
  } catch (error) {
    console.log(error);
  }
}
